import React from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import logo from "./assets/logo.svg";

function ScrollToSection() {
	const { hash } = useLocation();

	React.useEffect(() => {
		if (hash) {
			const element = document.getElementById(hash.substring(1)); // Remove the '#' from the hash
			if (element) {
				element.scrollIntoView({ behavior: "smooth" });
			}
		}
	}, [hash]);

	return <Home />;
}

function App() {
	return (
		<Router>
			<Navbar />
			<Routes>
				<Route path="/" element={<ScrollToSection />} />
				{/* <Route
					path="./pages/SurrogateMotherhood"
					element={<SurrogateMotherhood />}
				/>
				<Route path="./pages/IVFPrograms" element={<IVFPrograms />} />
				<Route path="./pages/Services" element={<Services />} />
				<Route path="./pages/About" element={<About />} />
				<Route path="./pages/FAQ" element={<FAQ />} /> */}
			</Routes>
		</Router>
	);
}

export default App;
